module.exports = __webpack_public_path__ + "static/media/icon_193.e7ccb7dd.svg";